export const BreakPoints = {
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px'
}